import envConfig from '../services/config/envConfig';
import huoneistokeskusPic1 from './img/LandingImages/hk-landing-pic1.jpg';
import huoneistokeskusPic2 from './img/LandingImages/hk-landing-pic2.jpg';
import isannointiPic1 from './img/LandingImages/realia-isannointi-landing-pic1.jpg';
import isannointiPic2 from './img/LandingImages/realia-isannointi-landing-pic2.jpg';
import realiaPic1 from './img/LandingImages/realia-landing-pic1.jpg';
import realiaPic2 from './img/LandingImages/realia-landing-pic2.jpg';
import huoneistokeskus from './img/omaKotiLogoHuoneistokeskus.svg';
import realia from './img/omaKotiLogoRealia.svg';
import isannointi from './img/omaKotiLogoRealiaIsannointi.svg';
import omaKotiPhoneHuoneistokeskus from './img/OmaKotiPhone/omakoti-iphone-huoneistokeskus.png';
import omaKotiPhoneRealia from './img/OmaKotiPhone/omakoti-iphone-realia-asuntovuokraus.png';
import omaKotiPhoneIsannointi from './img/OmaKotiPhone/omakoti-iphone-realia-isannointi.png';

// when adding a new cluster
// - make sure the id matches the actual cluster in DB
// - omit OmaKotiSignUp.url && OmaKotiSignUp.urlText if the cluster have no external url
// - add the cluster specific landingCarouselOffers in assets/carouselOffers.js

// when adding a new hardcoded value for a cluster, remember to add that value to all clusters
// inclusing the test cluster C_1001

export const landingClusters = [
  {
    id: 'OmaKoti-HK',
    logoUrl: huoneistokeskus,
    displayId: 'huoneistokeskus',
    displayName: 'Huoneistokeskus',
    OmaKotiExclusive: 'Huoneistokeskuksen',
    CodeSignUp:
      'Oma Koti on saatavilla yksinoikeudella Huoneistokeskuksen asiakkaille. Löydät kutsukoodin sähköpostistasi.',

    cookieBanner:
      'Huoneistokeskuksen Oma Koti -palvelun tuottaa Arkkeo. Käytämme evästeitä, joiden avulla voimme tarjota yksilöityä sisältöä ja parempaa palvelua. Lue lisää ',
    clusterColor: '#F58437',
    OmaKotiExclusivePic1: huoneistokeskusPic1,
    OmaKotiExclusivePic2: huoneistokeskusPic2,
    OmaKotiPhone: omaKotiPhoneHuoneistokeskus,
    OmaKotiInfo: {
      title:
        'Oma Koti tarjoaa käyttöösi eksklusiivisia etuja asumiseen ja sisustamiseen, joita et löydä muualta.',
      description:
        'Onko suunnitelmissa isompia tai pienempiä sisustushankintoja? Kaipaako asuntosi pientä pintaremonttia? Tarvitsetko apua muuttosi kanssa? Runsaasti asumiseen, sisustamiseen ja muuton helpottamiseen liittyviä etuja käden ulottuvillasi.',
    },
    OmaKotiSignUp: {
      title: 'Ota edut käyttöön',
      description:
        'Saat edut käyttöösi kirjautumalla Arkkeoon, joka toimii Huoneistokeskuksen Oma Koti -etuohjelman alustana. Rekisteröidy palveluun käyttäen välittäjältä tai sähköpostilla saamaasi kutsukoodia ja nauti eduista.',
    },
  },
  {
    id: 'OmaKoti-Realia',
    logoUrl: realia,
    displayId: 'asuntovuokraus',
    displayName: 'Realia Asuntovuokraus',
    OmaKotiExclusive: 'Realian',
    CodeSignUp:
      'Oma Koti on saatavilla yksinoikeudella joulukuusta 2021 alkaen Realian asiakkaille. Löydät kutsukoodin sähköpostistasi.',
    cookieBanner:
      'Realian Oma Koti -palvelun tuottaa Arkkeo. Käytämme evästeitä, joiden avulla voimme tarjota yksilöityä sisältöä ja parempaa palvelua. Lue lisää ',
    clusterColor: '#1E407B',
    OmaKotiExclusivePic1: realiaPic1,
    OmaKotiExclusivePic2: realiaPic2,
    OmaKotiPhone: omaKotiPhoneRealia,
    OmaKotiInfo: {
      title:
        'Oma Koti tarjoaa käyttöösi eksklusiivisia etuja asumiseen ja sisustamiseen, joita et löydä muualta.',
      description:
        'Onko suunnitelmissa isompia tai pienempiä sisustushankintoja? Kaipaako asuntosi pientä pintaremonttia? Tarvitsetko apua muuttosi kanssa? Runsaasti asumiseen, sisustamiseen ja muuton helpottamiseen liittyviä etuja käden ulottuvillasi.',
    },
    OmaKotiSignUp: {
      title: 'Ota edut käyttöön',
      description:
        'Saat edut käyttöösi kirjautumalla Arkkeoon, joka toimii Realian Oma Koti -etuohjelman alustana. Rekisteröidy palveluun käyttäen sähköpostilla saamaasi kutsukoodia ja nauti eduista.',
    },
  },
  {
    id: 'OmaKoti-Isannointi',
    logoUrl: isannointi,
    displayId: 'isannointi',
    displayName: 'Realia Isännöinti',
    OmaKotiExclusive: 'Realian',
    CodeSignUp: 'Oma Koti on saatavilla yksinoikeudella Realian asiakkaille.',
    cookieBanner:
      'Realian Oma Koti -palvelun tuottaa Arkkeo. Käytämme evästeitä, joiden avulla voimme tarjota yksilöityä sisältöä ja parempaa palvelua. Lue lisää ',
    clusterColor: '#1E407B',
    OmaKotiExclusivePic1: isannointiPic1,
    OmaKotiExclusivePic2: isannointiPic2,
    OmaKotiPhone: omaKotiPhoneIsannointi,
    OmaKotiInfo: {
      title:
        'Oma Koti tarjoaa käyttöösi ainutlaatuisia etuja asumiseen ja sisustamiseen, joita et löydä muualta.',
      description:
        'Onko suunnitelmissa isompia tai pienempiä sisustushankintoja? Kaipaako asuntosi pientä pintaremonttia? Tarvitsetko apua muuttosi kanssa? Runsaasti etuja käden ulottuvillasi asumiseen, sisutamiseen, hyvinvointiin ja kotonaviihtymiseen.',
    },
    OmaKotiSignUp: {
      title: 'Ota edut käyttöön',
      description:
        'Saat edut käyttöösi kirjautumalla Arkkeoon, joka toimii Realian Oma Koti -etuohjelman alustana. Palvelu on käytössä Realian isännöimien taloyhtiöiden asukkailla, osakkailla ja hallituksilla. Aktivointikoodin ja tarkemmat rekisteöritymisohjeet löydät',
      url: 'https://www.omarealia.fi',
      urlText: 'OmaRealiasta',
    },
  },
];

// REMEMBER TO ADD DATA TO THIS TEST CLUSTER

if (!envConfig.isProdEnv()) {
  landingClusters.push({
    id: 'C_1001',
    logoUrl: realia,
    displayId: 'test_cluster',
    OmaKotiExclusive: 'Realia Asuntovuokrauksen',
    CodeSignUp: 'Realia Asuntovuokrauksen',
    clusterColor: '#1E407B',
    OmaKotiExclusivePic1: realiaPic1,
    OmaKotiExclusivePic2: realiaPic2,
    OmaKotiPhone: omaKotiPhoneRealia,
    OmaKotiInfo: {
      title: 'test test_cluster',
      description: 'des test_cluster',
    },
    OmaKotiSignUp: {
      title: 'Ota edut käyttöön',
      description: 'This is just a test string in Finnish',
      url: 'https://www.arkkeo.com/',
      urlText: 'ARKKEO',
    },
  });
}
